import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';

import Transition from '@ember/routing/-private/transition';
import { Authenticated2faSetupRouteModel } from 'cio/pods/authenticated/2fa-setup/route';

export default class Authenticated2faSetupNewTotp extends Route {
  @service auth!: AuthService;

  beforeModel(transition: Transition) {
    // make sure user can't visit OTP code setup page without getting 2FA back-up codes first:
    if (!transition.from || transition.from.name !== 'authenticated.2fa_setup.index') {
      this.router.transitionTo('authenticated.2fa_setup.index');
      return;
    }

    super.beforeModel(transition);
  }

  model() {
    let { user, secret } = this.modelFor('authenticated.2fa_setup') as Authenticated2faSetupRouteModel;
    return { user, secret };
  }
}
